import React from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    Button,
    Box,
    Heading
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import Sort from './sort'

const FiltersHeader = ({
    refinements,
    handleFilterClick,
    sortUrls,
    productSearchResult,
    containerProps
}) => {
    return (
        <Box {...containerProps}>
            <Flex justify="space-between" align="center" mb={4}>
                <Flex align="center">
                    {/* Desktop only: Browse By section - use CSS display to prevent CLS */}
                    <Heading as="h3" variant="plpH3" mr={2} display={{base: 'none', md: 'block'}}>
                        <FormattedMessage
                            defaultMessage="Browse By"
                            id="plp.filters.browse.by"
                        />
                    </Heading>
                    <Button
                        fontSize="sm"
                        colorScheme="black"
                        variant="filter"
                        display={{base: 'none', md: 'inline-flex'}}
                        onClick={() => handleFilterClick('Category')}
                    >
                        <FormattedMessage
                            defaultMessage="Category"
                            id="product_list.button.categories"
                        />
                    </Button>
                    <Box
                        w={'1px'}
                        h={'26px'}
                        bg="gray.50"
                        mx={'24px'}
                        display={{base: 'none', md: 'block'}}
                    />
                    <Heading as="h3" variant="plpH3" mr={2} display={{base: 'none', md: 'block'}}>
                        <FormattedMessage
                            defaultMessage="Refine By"
                            id="plp.filters.refine.by"
                        />
                    </Heading>

                    {/* Filter buttons - visible on all breakpoints */}
                    {Object.keys(refinements).map((key) => (
                        <Button
                            key={key}
                            fontSize="sm"
                            colorScheme="black"
                            variant="filter"
                            marginRight={2}
                            display="inline-flex"
                            onClick={() => handleFilterClick(refinements[key]?.[0]?.attributeId)}
                        >
                            {key}
                        </Button>
                    ))}
                </Flex>
                <Flex display={{base: 'none', md: 'flex'}} align="center">
                    <Sort sortUrls={sortUrls} productSearchResult={productSearchResult} />
                </Flex>
            </Flex>
        </Box>
    )
}

FiltersHeader.propTypes = {
    handleFilterClick: PropTypes.func.isRequired,
    refinements: PropTypes.object.isRequired,
    sortUrls: PropTypes.array.isRequired,
    productSearchResult: PropTypes.object.isRequired,
    containerProps: PropTypes.object
}

export default FiltersHeader
